import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';

import ContentContainer from '~/components/atoms/content-container/ContentContainer';
import { Text } from '~/components/ui/text';
import { useAppDispatch } from '~/hooks/useRedux';
import { getLoggedInUser } from '~/store/reducers/account/selector';
import { getAccountTaxInfoThunk, getAccountThunk, updateAccountTaxInfoThunk } from '~/store/reducers/account/slice';
import { COLORS } from '~/styles/colors';

import BillingInformation from './components/BillingInformation';
import GeneralInformation from './components/GeneralInformation';
import * as S from './styles';

export default function Settings() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { data, taxData } = useSelector(getLoggedInUser);
  const [currentTab, setCurrentTab] = useState(1);

  useEffect(() => {
    dispatch(getAccountThunk());
    dispatch(getAccountTaxInfoThunk());
  }, [dispatch]);

  const handleTabItemClick = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const handleChangeTaxType = (field, value) => {
    dispatch(updateAccountTaxInfoThunk({ [field]: value }));
  };

  const handleChangeTaxInfo = (payload) => {
    dispatch(updateAccountTaxInfoThunk(payload));
  };

  if (Object.keys(data).length === 0 && data.constructor === Object) {
    return;
  }

  return (
    <Box sx={S.settingsContainer}>
      <Box sx={S.topTitle}>
        <Text variant="h2">{t('settings:settingsTitle')}</Text>
      </Box>
      <TabContext value={currentTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleTabItemClick}
            TabIndicatorProps={{
              style: {
                backgroundColor: COLORS.primary,
              },
            }}
          >
            <Tab
              label={
                <Text variant="h3" sx={{ color: currentTab === 1 ? COLORS.primary : COLORS.grey400 }}>
                  {t('settings:tab1')}
                </Text>
              }
              value={1}
              sx={{
                textTransform: 'none',
              }}
            />
            <Tab
              label={
                <Text variant="h3" sx={{ color: currentTab === 2 ? COLORS.primary : COLORS.grey400 }}>
                  {t('settings:tab2')}
                </Text>
              }
              value={2}
              sx={{
                textTransform: 'none',
              }}
            />
          </TabList>
        </Box>
      </TabContext>
      {currentTab === 1 ? (
        <GeneralInformation data={data} />
      ) : (
        <ContentContainer display="flex" justifyContent="space-between" containerStyles={{ mb: 3 }}>
          <BillingInformation
            isPayment={false}
            data={taxData}
            handleChangeTaxInfo={handleChangeTaxInfo}
            handleChangeTaxType={handleChangeTaxType}
          />
        </ContentContainer>
      )}
    </Box>
  );
}
